import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { TaskState, TaskStore } from './types';
import { checkDevEnv } from '../utils';

const initialState: TaskState = {
    taskNames: {},
};

const PREFIX = 'task';

export const useTaskStore = create<TaskStore>()(
    devtools(
        (set) => ({
            ...initialState,

            setTaskName: (id, name) =>
                set(
                    (state) =>
                        state.taskNames[id] === name
                            ? state
                            : { taskNames: { ...state.taskNames, [id]: name } },
                    undefined,
                    `${PREFIX}/setTaskName`,
                ),
        }),
        {
            name: 'TaskStore',
            enabled: checkDevEnv(),
            store: 'TaskStore',
        },
    ),
);
